import React from "react";
import { Reveal } from "./Reveal";
type SectionHeadingProps = {
  id: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  aside?: React.ReactNode;
};
export function SectionHeading({
  id,
  title,
  subtitle,
  align = "left",
  aside
}: SectionHeadingProps) {
  const centered = align === "center";
  return <Reveal className={`flex flex-col gap-6 ${centered ? "items-center text-center" : "lg:flex-row lg:items-end lg:justify-between"}`} data-id="element-331" data-mp="3k0p0pcx6kagq">
      <div className={centered ? "max-w-3xl" : "max-w-2xl"} data-id="element-332" data-mp="gj6u18t599hw">
        <span className={`block h-px w-16 bg-gold ${centered ? "mx-auto" : ""}`} aria-hidden="true" data-id="element-333" data-mp="giooflkldixb" />
        <h2 id={id} className="mt-6 font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-334" data-mp="1uaekqorcu79">
          {title}
        </h2>
        {subtitle && <p className="mt-4 text-base text-smoke sm:text-lg" data-id="element-335" data-mp="uig03fnmyn85">{subtitle}</p>}
      </div>
      {aside}
    </Reveal>;
}